module.exports = __webpack_public_path__ + "img/06-03-cp-pg.5c750747.jpg";